import { render, staticRenderFns } from "./noneList.vue?vue&type=template&id=fd72cfe4&scoped=true&"
import script from "./noneList.vue?vue&type=script&lang=js&"
export * from "./noneList.vue?vue&type=script&lang=js&"
import style0 from "./noneList.vue?vue&type=style&index=0&id=fd72cfe4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd72cfe4",
  null
  
)

export default component.exports